// extracted by mini-css-extract-plugin
export default {"button":"lightRedButton_button__9ImmD"};